import { ApiResult, request, safeRequest } from '@synergy/api';
import { CustomerBonusSettlement, Media } from '@synergy/models';

import { BonusSettlementDetail } from '../../models/bonus-settlement-detail';
import { BonusSettlementDetailFormValues } from '../../models/bonus-settlement-detail-form-values';

export class BonusSettlementsDetailApi {
    constructor(protected baseUrl: string) {}

    public getBonusSettlementDetail(id: number): Promise<ApiResult<BonusSettlementDetail>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/supplier-bonus-settlements/${id}/details`),
            response => response.data
        );
    }

    public saveBonusSettlementDetail(id: number, values: BonusSettlementDetailFormValues): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/supplier-bonus-settlements/${id}/save`, values),
            () => null
        );
    }

    public submitBonusSettlementDetail(id: number): Promise<ApiResult<null>> {
        return safeRequest(
            () => request.post(`${this.baseUrl}/supplier-bonus-settlements/${id}/submit`),
            () => null
        );
    }

    public updateNoteFromSupplier(id: number, note: string): Promise<ApiResult<null>> {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/supplier-bonus-settlements/${id}/update-note-from-supplier`, {
                    noteFromSupplier: note,
                }),
            () => null
        );
    }

    public uploadFile(supplierBonusSettlementId: number, file: File): Promise<ApiResult<Media>> {
        return safeRequest(
            () => {
                const data = new FormData();
                data.append('file', file, file.name);

                const config = { headers: { 'content-type': 'multipart/form-data' } };

                return request.post(
                    `${this.baseUrl}/supplier-bonus-settlements/${supplierBonusSettlementId}/upload-file`,
                    data,
                    config
                );
            },
            response => response.data
        );
    }

    public deleteFiles(supplierBonusSettlementId: number, deletedFileIds: number[]): Promise<ApiResult<null>> {
        return safeRequest(
            () =>
                request.delete(`${this.baseUrl}/supplier-bonus-settlements/${supplierBonusSettlementId}/remove-files`, {
                    data: { documentIds: deletedFileIds },
                }),
            () => null
        );
    }

    public addCustomer(
        supplierBonusSettlementId: number,
        customerId: number
    ): Promise<ApiResult<CustomerBonusSettlement>> {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/supplier-bonus-settlements/${supplierBonusSettlementId}/add-customer`, {
                    customerId,
                }),
            response => response.data
        );
    }

    public deleteCustomer(
        supplierBonusSettlementId: number,
        customerBonusSettlementId: number
    ): Promise<ApiResult<null>> {
        return safeRequest(
            () =>
                request.delete(
                    `${this.baseUrl}/supplier-bonus-settlements/${supplierBonusSettlementId}/customers/${customerBonusSettlementId}/remove`
                ),
            () => null
        );
    }
}
